import { render, staticRenderFns } from "./LandingPagePreview.vue?vue&type=template&id=56dede01&"
import script from "./LandingPagePreview.vue?vue&type=script&lang=js&"
export * from "./LandingPagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports